import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-right\"><path d=\"M9 11.292c.004 0-.354.354 0 .708s.708 0 .708 0L14 7.5 9.707 3S9.354 2.646 9 3s-.004.707 0 .707L12 7H1.5S1 7 1 7.5s.5.5.5.5H12l-3 3.292z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol